import type { ReactNode } from "react"
import { PanelRight } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "../Button/Button"

export interface ChatHeaderProps {
  title?: string
  onCollapse?: () => void
  deployCtaSlot?: ReactNode
  className?: string
}

export function ChatHeader({
  title = "Chat",
  onCollapse,
  deployCtaSlot,
  className,
}: ChatHeaderProps) {
  return (
    <div
      className={cn(
        "h-11 shrink-0 flex items-center gap-2 px-3 border-b border-border",
        className,
      )}
    >
      {onCollapse && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onCollapse}
          className="h-7 w-7 p-0 text-muted-foreground hover:text-foreground hover:bg-muted"
          aria-label="Collapse chat"
        >
          <PanelRight size={14} strokeWidth={1.5} />
        </Button>
      )}
      <span className="text-label text-foreground">{title}</span>
      <div className="flex-1" />
      {deployCtaSlot}
    </div>
  )
}
